module.exports = __webpack_public_path__ + "img/back-arrow.4c20acad.svg";